import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import api, { formatApiError } from "@/lib/api";
import { CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-nx flex min-h-[80vh] items-center justify-center py-12">
      <div className="w-full max-w-md">
        <div className="card-nx p-8 animate-fade-up">
          <div className="flex justify-center"><Logo /></div>
          {sent ? (
            <div className="mt-6 text-center" data-testid="forgot-success">
              <CheckCircle2 className="mx-auto h-12 w-12 text-emerald-500" />
              <h1 className="mt-4 text-xl font-bold text-[#0B192C] font-head">Check your email</h1>
              <p className="mt-2 text-sm text-slate-500">
                If that email is registered, a reset link has been sent. The link expires in 1 hour.
              </p>
              <Link to="/login" className="btn-outline-navy mt-6 inline-flex" data-testid="forgot-back-to-login">
                Back to sign in
              </Link>
            </div>
          ) : (
            <>
              <h1 className="mt-6 text-center text-2xl font-bold text-[#0B192C] font-head">Forgot password</h1>
              <p className="mt-2 text-center text-sm text-slate-500">
                Enter your email and we'll send you a reset link.
              </p>
              <form onSubmit={submit} className="mt-7 space-y-4" data-testid="forgot-form">
                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                  className="input-nx" placeholder="you@example.com" data-testid="forgot-email-input" />
                {error && <p className="text-sm text-red-600">{error}</p>}
                <button type="submit" disabled={loading} className="btn-gold w-full" data-testid="forgot-submit-btn">
                  {loading ? "Sending..." : "Send reset link"}
                </button>
              </form>
              <p className="mt-6 text-center text-sm text-slate-500">
                <Link to="/login" className="font-semibold text-[#0B192C] hover:underline" data-testid="forgot-login-link">
                  Back to sign in
                </Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
